export const iso8601Regex = /(\d{4}-[01]\d-[0-3]\d)(T([0-2]\d:[0-5]\d:[0-5]\d(\.\d+)?)(([+-][0-2]\d:[0-5]\d)|Z))?/;

export const timeSpanFormat = 'HH:mm:ss.SSS';
